import type { Cartography, Node, Relationship, Workspace, WorkspaceWithLabels } from '@graphit/types'
import axios from 'axios'

import env from '../environments'

export async function getWorkspaces() {
	const response = await axios.get<Workspace[]>(`${env.apiUrl}/workspaces`)

	return response.data
}

export async function getWorkspace(id: string) {
	const response = await axios.get<WorkspaceWithLabels>(`${env.apiUrl}/workspaces/${id}`)

	return response.data
}

export async function importData(nodes: Node[], relationships: Relationship[], createCartography: boolean) {
	const response = await axios.post<Cartography | undefined>(`${env.apiUrl}/workspaces/import`, {
		nodes,
		relationships,
		createCartography
	})

	return response.data
}

export async function createWorkspace(workspaceName: string) {
	const response = await axios.post<Workspace>(`${env.apiUrl}/workspaces/create`, {
		workspaceName
	})

	return response.data
}

export async function scanWorkspace(id: string) {
	const response = await axios.get(`${env.apiUrl}/workspaces/${id}/scan`)

	// eslint-disable-next-line @typescript-eslint/no-unsafe-return
	return response.data
}

export async function shareWorkspace(workspaceId: string, userId: string, shared: boolean) {
	await axios.put(`${env.apiUrl}/workspaces/share/${workspaceId}`, {
		userId,
		shared
	})
}

export async function duplicateWorkspace(workspaceId: string) {
	const response = await axios.get<Workspace>(`${env.apiUrl}/workspaces/duplicate/${workspaceId}`)

	return response.data
}

export async function seedWorkspace(workspaceId: string) {
	await axios.put(`${env.apiUrl}/workspaces/seed/${workspaceId}`)
}

export async function updateWorkspace(id: string, workspace: Partial<Workspace>) {
	await axios.put(`${env.apiUrl}/workspaces/${id}`, {
		workspace
	})
}

export async function deleteWorkspace(id: string) {
	await axios.delete(`${env.apiUrl}/workspaces/${id}`)
}
